module.exports = __webpack_public_path__ + "img/product-placeholder-28.5ed9e35.png";